(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[280],{

/***/ 8264:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advisors",
      function () {
        return __webpack_require__(45596);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32234:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/charles-schwab-logo.cb74bef1.svg","height":27,"width":186});

/***/ }),

/***/ 27754:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/fidelity-logo.3fc5a7d3.svg","height":33,"width":137});

/***/ }),

/***/ 53736:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/reproRightsDT.d6d01d8c.png","height":1888,"width":3454,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAADFBMVEX////y8PD29fP85t1AzSsVAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGklEQVQImWNgYGBiZGIAA0ZGJmYoAyoEYQAAAbUAF/u24ykAAAAASUVORK5CYII="});

/***/ }),

/***/ 64742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FeeComparison; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97700);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49423);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56050);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93636);
/* harmony import */ var _images_logos_charles_schwab_logo_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32234);
/* harmony import */ var _images_logos_fidelity_logo_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27754);
/* harmony import */ var _cardTable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57216);
/* harmony import */ var _sectionLabel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12219);
/* harmony import */ var _FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89320);
/* harmony import */ var _FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4__);









var FeeComparison = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["fee-section"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_5__/* .Card */ .Z, {
                className: (_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["fee-comparison"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sectionLabel__WEBPACK_IMPORTED_MODULE_6__/* .SectionLabel */ .e, {
                        text: "Fee Comparison",
                        smaller: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable */ .c, {
                        headers: [
                            "Service",
                            "Donation Fee",
                            "Granting Fee",
                            "Total Fee"
                        ],
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Row */ .c.Row, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["logo-cell"]),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_8__/* .LogoIcon */ .K, {
                                                    color: "currentColor"
                                                }),
                                                "for Donors"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "0.5%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "1.0%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "1.5%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Row */ .c.Row, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                    header: true,
                                    colSpan: 4,
                                    className: (_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["full-row-col"]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {})
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Row */ .c.Row, {
                                className: (_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["fake-second-header"]),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        header: true,
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        header: true,
                                        children: "Admin Fee"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        header: true,
                                        children: "Investment Fee"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        header: true,
                                        children: "Total Fee*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Row */ .c.Row, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            src: _images_logos_charles_schwab_logo_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                                            alt: "Charles Schwab",
                                            width: 190,
                                            height: 25
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "1.2%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "1.6%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "2.8%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Row */ .c.Row, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            src: _images_logos_fidelity_logo_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                                            alt: "Fidelity",
                                            width: 140,
                                            height: 33
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "1.2%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "1.2%"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cardTable__WEBPACK_IMPORTED_MODULE_7__/* .CardTable.Col */ .c.Col, {
                                        center: true,
                                        children: "2.4%"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, {
                        as: "a",
                        size: "small",
                        href: "https://docs.endaoment.org/donors/fee-schedule",
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            "Read more about fees",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_10__/* .ArrowIcon */ .e, {
                                width: 20
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_FeeComparison_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["fee-footnote"]),
                children: "*Based on 4.5yr average granting schedule"
            })
        ]
    });
};


/***/ }),

/***/ 57216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ CardTable; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6277);
/* harmony import */ var _CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16962);
/* harmony import */ var _CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var Column = function(_param) {
    var _header = _param.header, header = _header === void 0 ? false : _header, _center = _param.center, center = _center === void 0 ? false : _center, children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "header",
        "center",
        "children",
        "className"
    ]);
    var Element = header ? "th" : "td";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(header ? (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["card-table-header"]) : (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["card-table-column"]), center && (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default().center), className)
    }, props), {
        children: children
    }));
};
var Row = function(_param) {
    var _bold = _param.bold, bold = _bold === void 0 ? false : _bold, _center = _param.center, center = _center === void 0 ? false : _center, children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "bold",
        "center",
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["card-table-row"]), bold && (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default().bold), center && (_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default().center), className)
    }, props), {
        children: children
    }));
};
var CardTable = function(_param) {
    var headers = _param.headers, children = _param.children, className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "headers",
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_CardTable_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["card-table"]), className)
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, {
                    children: headers.map(function(val, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Column, {
                            header: true,
                            children: val !== "" ? val : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: "\xa0"
                            })
                        }, i + val);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                children: children
            })
        ]
    }));
};

CardTable.Row = Row;
CardTable.Col = Column;


/***/ }),

/***/ 63993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ DoubleFeature; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1401);
/* harmony import */ var _DoubleFeature_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85849);
/* harmony import */ var _DoubleFeature_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_DoubleFeature_module_scss__WEBPACK_IMPORTED_MODULE_1__);



var DoubleFeature = function(param) {
    var pillLeft = param.pillLeft, pillRight = param.pillRight, headerLeft = param.headerLeft, headerRight = param.headerRight, extraLeft = param.extraLeft, extraRight = param.extraRight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_DoubleFeature_module_scss__WEBPACK_IMPORTED_MODULE_1___default()["double-feature"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_2__/* .Pill */ .D, {
                        size: "large",
                        variation: "orange",
                        children: pillLeft
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: headerLeft
                    }),
                    extraLeft && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: extraLeft
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_2__/* .Pill */ .D, {
                        size: "large",
                        variation: "blue",
                        children: pillRight
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        children: headerRight
                    }),
                    extraRight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: extraRight
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 45792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ TextGridWithLogo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6277);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49423);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97700);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93636);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1401);
/* harmony import */ var _TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46151);
/* harmony import */ var _TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3__);






var TextItem = function(param) {
    var header = param.header, text = param.text, buttonText = param.buttonText, _buttonArrow = param.buttonArrow, buttonArrow = _buttonArrow === void 0 ? true : _buttonArrow, _comingSoon = param.comingSoon, comingSoon = _comingSoon === void 0 ? false : _comingSoon, href = param.href, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["text-item"]), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(comingSoon && (_TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["coming-soon"])),
                children: header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: text
            }),
            buttonText && href && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: href,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                    as: "a",
                    target: "_blank",
                    rel: "noreferrer",
                    children: [
                        buttonText,
                        buttonArrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_5__/* .ArrowIcon */ .e, {
                            width: 20,
                            height: 12
                        })
                    ]
                })
            })
        ]
    });
};
var TextGridWithLogo = function(param) {
    var headerText = param.headerText, pillText = param.pillText, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["text-grid-container"]), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_6__/* .LogoIcon */ .K, {
                color: "#8478E0",
                width: 62
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_7__/* .Pill */ .D, {
                variation: "orange",
                size: "large",
                className: (_TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default().pill),
                children: pillText
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: headerText
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["text-grid"]),
                children: children
            })
        ]
    });
};
TextGridWithLogo.Item = TextItem;


/***/ }),

/***/ 22980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ TwoScreensSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49423);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93636);
/* harmony import */ var _sectionLabel__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12219);
/* harmony import */ var _TwoScreensSection_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78091);
/* harmony import */ var _TwoScreensSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_TwoScreensSection_module_scss__WEBPACK_IMPORTED_MODULE_8__);










var TwoScreensButton = function(_param) {
    var text = _param.text, href = _param.href, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "href"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            as: "a",
            target: "_blank",
            rel: "noreferrer"
        }, props), {
            children: [
                text,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_7__/* .ArrowIcon */ .e, {
                    width: 20,
                    height: 12
                })
            ]
        }))
    });
};
var TwoScreensSection = function(param) {
    var title = param.title, image1Src = param.image1Src, image2Src = param.image2Src, subtext = param.subtext, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_TwoScreensSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["two-screens-section"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sectionLabel__WEBPACK_IMPORTED_MODULE_9__/* .SectionLabel */ .e, {
                text: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_TwoScreensSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().screenshot),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: image1Src,
                            alt: "Product screenshot",
                            priority: true,
                            layout: "fill",
                            placeholder: "blur"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_TwoScreensSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().screenshot),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: image2Src,
                            alt: "Product screenshot",
                            priority: true,
                            layout: "fill",
                            placeholder: "blur"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: subtext
            }),
            children
        ]
    });
};
TwoScreensSection.Button = TwoScreensButton;


/***/ }),

/***/ 45596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ advisors; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../libs/config/src/lib/config.ts
var config = __webpack_require__(46518);
// EXTERNAL MODULE: ../../libs/ui/icons/src/lib/StarCircleIcon.tsx
var StarCircleIcon = __webpack_require__(95492);
// EXTERNAL MODULE: ../../libs/ui/icons/src/lib/SupportIcon.tsx
var SupportIcon = __webpack_require__(95368);
// EXTERNAL MODULE: ../../libs/ui/icons/src/lib/EthereumIcon.tsx
var EthereumIcon = __webpack_require__(80480);
// EXTERNAL MODULE: ../../libs/ui/icons/src/lib/LaptopIcon.tsx
var LaptopIcon = __webpack_require__(71606);
// EXTERNAL MODULE: ../../libs/ui/icons/src/lib/DonutIcon.tsx
var DonutIcon = __webpack_require__(75534);
// EXTERNAL MODULE: ../../libs/ui/icons/src/lib/LogoIcon.tsx
var LogoIcon = __webpack_require__(97700);
// EXTERNAL MODULE: ../../libs/ui/icons/src/lib/StarIcon.tsx
var StarIcon = __webpack_require__(9357);
// EXTERNAL MODULE: ../../libs/ui/shared/src/lib/pill/Pill.tsx
var Pill = __webpack_require__(1401);
// EXTERNAL MODULE: ./content/imageButtonRow/ImageButtonRow.tsx + 1 modules
var ImageButtonRow = __webpack_require__(32985);
// EXTERNAL MODULE: ./content/advisors/advisorsHeader/AdvisorsHeader.module.scss
var AdvisorsHeader_module = __webpack_require__(34246);
var AdvisorsHeader_module_default = /*#__PURE__*/__webpack_require__.n(AdvisorsHeader_module);
;// CONCATENATED MODULE: ./content/advisors/advisorsHeader/AdvisorsHeader.tsx





var AdvisorsHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (AdvisorsHeader_module_default())["advisors-header"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* Pill */.D, {
                size: "large",
                variation: "blue",
                children: "For Financial Professionals"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Full-featured philanthropic services for clients of all kinds."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (AdvisorsHeader_module_default())["advisors-header-details"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StarCircleIcon/* StarCircleIcon */.a, {
                                color: "#ADBACC",
                                strokeColor: "#ADBACC",
                                width: 45,
                                height: 45
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Best-in-class donor portal"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportIcon/* SupportIcon */.C, {
                                color: "#ADBACC",
                                strokeColor: "#ADBACC",
                                width: 45,
                                height: 45
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Bespoke customer service"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EthereumIcon/* EthereumIcon */.x, {
                                color: "#ADBACC",
                                strokeColor: "#ADBACC",
                                width: 45,
                                height: 45
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "1000+ native assets accepted"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LaptopIcon/* LaptopIcon */.n, {
                                color: "#ADBACC",
                                strokeColor: "#ADBACC",
                                width: 45,
                                height: 45
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Client directed and managed"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (AdvisorsHeader_module_default())["coming-soon"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DonutIcon/* DonutIcon */.S, {
                                color: "#ADBACC",
                                strokeColor: "#ADBACC",
                                width: 45,
                                height: 45
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Yield bearing & crypto portfolio options"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoIcon/* LogoIcon */.K, {
                                color: "#ADBACC",
                                strokeColor: "#ADBACC",
                                width: 45,
                                height: 45,
                                strokeWidth: 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Industry-low fees, values-aligned with philanthropic throughput "
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageButtonRow/* ImageButtonRow */.p, {
                title: "Learn More",
                className: (AdvisorsHeader_module_default())["learn-more-container"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageButtonRow/* ImageButtonRow.Button */.p.Button, {
                        label: "Request a Demo",
                        paragraph: "Learn more about how the app works",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarIcon/* StarIcon */.r, {}),
                        href: "https://endaoment.typeform.com/request-demo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageButtonRow/* ImageButtonRow.Button */.p.Button, {
                        label: "Read our FAQ",
                        paragraph: "Find answers to your Endaoment questions",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarIcon/* StarIcon */.r, {}),
                        href: "/learn#faq-section"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageButtonRow/* ImageButtonRow.Button */.p.Button, {
                        label: "Contact Us",
                        paragraph: "Contact an Endaoment representative",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarIcon/* StarIcon */.r, {}),
                        href: "mailto:partnerships@endaoment.org"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./content/advisors/feeComparison/FeeComparison.tsx
var FeeComparison = __webpack_require__(64742);
// EXTERNAL MODULE: ./content/doubleFeature/DoubleFeature.tsx
var DoubleFeature = __webpack_require__(63993);
// EXTERNAL MODULE: ./content/mediaCarousel/MediaCarousel.tsx
var MediaCarousel = __webpack_require__(19002);
// EXTERNAL MODULE: ./content/metaTags/MetaTags.tsx
var MetaTags = __webpack_require__(19055);
// EXTERNAL MODULE: ./content/ndaoTokenCallout/NDAOTokenCallout.tsx
var NDAOTokenCallout = __webpack_require__(57640);
// EXTERNAL MODULE: ./content/socialLinks/SocialLinks.tsx + 4 modules
var SocialLinks = __webpack_require__(37321);
// EXTERNAL MODULE: ./content/textGridWithLogo/TextGridWithLogo.tsx
var TextGridWithLogo = __webpack_require__(45792);
// EXTERNAL MODULE: ./content/twoScreensSection/TwoScreensSection.tsx
var TwoScreensSection = __webpack_require__(22980);
// EXTERNAL MODULE: ./images/screenshots/myFundsDT.png
var myFundsDT = __webpack_require__(53424);
// EXTERNAL MODULE: ./images/screenshots/reproRightsDT.png
var reproRightsDT = __webpack_require__(53736);
;// CONCATENATED MODULE: ./pages/advisors.tsx







// import { NDAOTokenCallout } from '../content/ndaoTokenCallout';





var AdvisorsPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* MetaTags */.N, {
                url: "/advisors",
                title: "Endaoment | Advisors"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvisorsHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoubleFeature/* DoubleFeature */.W, {
                pillLeft: "In-App Donations",
                pillRight: "OTC Donations",
                headerLeft: "Donate over 1,000+ different kinds of digital assets",
                headerRight: "Donate from other blockchains over-the-counter",
                extraLeft: "Industry-low 1.5% fee",
                extraRight: "Yes, even NFTs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextGridWithLogo/* TextGridWithLogo */.X, {
                headerText: "Self-directed, crypto-native, flexible giving without compromising on compliance.",
                pillText: "Built for Crypto Investors",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextGridWithLogo/* TextGridWithLogo.Item */.X.Item, {
                        header: "Donor-Advised Funds",
                        text: "Donate any asset at any time and get a tax receipt immediately. Come back later and make grant recommendations to more than 1.5 million nonprofits whenever inspiration strikes.",
                        buttonText: "Open a Fund",
                        href: "".concat(config/* config.clientBaseUrl */.v.clientBaseUrl, "/funds/create")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextGridWithLogo/* TextGridWithLogo.Item */.X.Item, {
                        header: "Direct Donations",
                        text: "Know where you want to give? Head straight to the profile of your favorite nonprofit and easily donate any crypto asset directly to the organization.",
                        buttonText: "Find an Org",
                        href: "".concat(config/* config.clientBaseUrl */.v.clientBaseUrl, "/orgs")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextGridWithLogo/* TextGridWithLogo.Item */.X.Item, {
                        header: "Community Funds",
                        text: "Not sure where to give? Community Funds leverage our incredible community's knowledge base to direct donations around specific issue areas and causes.",
                        buttonText: "Browse Community Funds",
                        href: "".concat(config/* config.clientBaseUrl */.v.clientBaseUrl, "/funds/community")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextGridWithLogo/* TextGridWithLogo.Item */.X.Item, {
                        header: "Endorsements",
                        text: "Soon you can help us curate the best and most effective nonprofits by endorsing them. Earn rewards for contributing your perspective while driving excess fee revenue to organizations you endorse.",
                        comingSoon: true,
                        // TODO: Figure out where this goes
                        href: "#"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextGridWithLogo/* TextGridWithLogo.Item */.X.Item, {
                        header: "Portfolio Allocations",
                        text: "Don't let your philanthropic capital sit idly by while you find the perfect organization to support. Easily deploy dollars in your Endaoment Fund into DeFi yield bearing and crypto investment options.",
                        comingSoon: true,
                        // TODO: Figure out where this goes
                        href: "#"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeComparison/* FeeComparison */.l, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoScreensSection/* TwoScreensSection */.U, {
                title: "Comprehensive On-Chain Donation Interface",
                image1Src: myFundsDT/* default */.Z,
                image2Src: reproRightsDT/* default */.Z,
                subtext: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoScreensSection/* TwoScreensSection.Button */.U.Button, {
                    text: "Launch App",
                    href: config/* config.clientBaseUrl */.v.clientBaseUrl
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NDAOTokenCallout/* NDAOTokenCallout */.d, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaCarousel/* MediaCarousel */.Q, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinks/* SocialLinks */.W, {})
        ]
    });
};
/* harmony default export */ var advisors = (AdvisorsPage);


/***/ }),

/***/ 75534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ DonutIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);




var DonutIcon = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 40 : _width, height = _param.height, _color = _param.color, color = _color === void 0 ? "currentColor" : _color, strokeColor = _param.strokeColor, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height",
        "color",
        "strokeColor"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: width,
        height: height !== null && height !== void 0 ? height : width,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M38.9997 19.9998C38.9997 23.7577 37.8854 27.4311 35.7976 30.5556C33.7099 33.6801 30.7425 36.1154 27.2708 37.5534C23.799 38.9915 19.9788 39.3677 16.2932 38.6346C12.6076 37.9015 9.22211 36.0919 6.56494 33.4348C3.90776 30.7776 2.0982 27.3921 1.36509 23.7065C0.631972 20.0209 1.00823 16.2007 2.44628 12.7289C3.88434 9.25716 6.31959 6.28979 9.4441 4.20206C12.2909 2.29987 15.5934 1.20576 19.0003 1.02631C19.5518 0.997255 19.9998 1.44772 19.9998 2L19.9998 10.8705C19.9998 11.4228 19.5505 11.8641 19.0023 11.9319C17.7479 12.087 16.542 12.5332 15.4834 13.2405C14.1466 14.1338 13.1046 15.4034 12.4893 16.8889C11.874 18.3743 11.713 20.0089 12.0267 21.5858C12.3404 23.1627 13.1146 24.6113 14.2515 25.7482C15.3884 26.8851 16.837 27.6593 18.4139 27.973C19.9908 28.2867 21.6254 28.1257 23.1108 27.5104C24.5963 26.8951 25.8659 25.8531 26.7592 24.5163C27.6524 23.1794 28.1292 21.6077 28.1292 19.9998H38.9997Z",
                fill: color,
                fillOpacity: "0.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M38.9997 19.9998H39.7497V19.2498H38.9997V19.9998ZM28.1292 19.9998V19.2498H27.3792V19.9998H28.1292ZM19.9998 10.8705H19.2498H19.9998ZM19.0003 1.02631L18.9608 0.277344L19.0003 1.02631ZM19.9998 2L20.7498 2L19.9998 2ZM38.2497 19.9998C38.2497 23.6093 37.1794 27.1377 35.174 30.1389L36.4212 30.9723C38.5914 27.7244 39.7497 23.906 39.7497 19.9998H38.2497ZM35.174 30.1389C33.1687 33.1401 30.3185 35.4792 26.9838 36.8605L27.5578 38.2463C31.1666 36.7515 34.2511 34.2201 36.4212 30.9723L35.174 30.1389ZM26.9838 36.8605C23.649 38.2418 19.9796 38.6032 16.4395 37.899L16.1469 39.3702C19.9779 40.1323 23.949 39.7411 27.5578 38.2463L26.9838 36.8605ZM16.4395 37.899C12.8994 37.1948 9.64755 35.4567 7.09527 32.9044L6.03461 33.9651C8.79667 36.7272 12.3158 38.6081 16.1469 39.3702L16.4395 37.899ZM7.09527 32.9044C4.54298 30.3521 2.80485 27.1003 2.10068 23.5602L0.629497 23.8529C1.39155 27.6839 3.27254 31.203 6.03461 33.9651L7.09527 32.9044ZM2.10068 23.5602C1.3965 20.0201 1.75791 16.3507 3.13919 13.0159L1.75337 12.4419C0.258556 16.0507 -0.132556 20.0218 0.629497 23.8529L2.10068 23.5602ZM3.13919 13.0159C4.52048 9.68121 6.85961 6.83098 9.86078 4.82566L9.02742 3.57845C5.77958 5.7486 3.24819 8.8331 1.75337 12.4419L3.13919 13.0159ZM9.86078 4.82566C12.5952 2.99856 15.7674 1.94763 19.0397 1.77527L18.9608 0.277344C15.4195 0.463879 11.9866 1.60118 9.02742 3.57845L9.86078 4.82566ZM19.2498 2L19.2498 10.8705L20.7498 10.8705L20.7498 2L19.2498 2ZM18.9103 11.1876C17.5401 11.357 16.223 11.8443 15.0667 12.6169L15.9001 13.8641C16.861 13.2221 17.9556 12.817 19.0944 12.6762L18.9103 11.1876ZM15.0667 12.6169C13.6065 13.5926 12.4684 14.9794 11.7964 16.6019L13.1822 17.1759C13.7407 15.8275 14.6866 14.675 15.9001 13.8641L15.0667 12.6169ZM11.7964 16.6019C11.1243 18.2244 10.9485 20.0097 11.2911 21.7321L12.7623 21.4395C12.4775 20.008 12.6237 18.5243 13.1822 17.1759L11.7964 16.6019ZM11.2911 21.7321C11.6337 23.4546 12.4794 25.0367 13.7212 26.2785L14.7819 25.2178C13.7498 24.1858 13.047 22.8709 12.7623 21.4395L11.2911 21.7321ZM13.7212 26.2785C14.963 27.5203 16.5451 28.366 18.2676 28.7086L18.5602 27.2374C17.1288 26.9527 15.8139 26.2499 14.7819 25.2178L13.7212 26.2785ZM18.2676 28.7086C19.99 29.0512 21.7753 28.8754 23.3978 28.2033L22.8238 26.8175C21.4754 27.376 19.9917 27.5222 18.5602 27.2374L18.2676 28.7086ZM23.3978 28.2033C25.0203 27.5312 26.4071 26.3932 27.3828 24.933L26.1356 24.0996C25.3247 25.3131 24.1722 26.259 22.8238 26.8175L23.3978 28.2033ZM27.3828 24.933C28.3585 23.4727 28.8792 21.756 28.8792 19.9998H27.3792C27.3792 21.4593 26.9464 22.8861 26.1356 24.0996L27.3828 24.933ZM28.1292 20.7498H38.9997V19.2498H28.1292V20.7498ZM19.2498 10.8705C19.2498 10.9887 19.1404 11.1591 18.9103 11.1876L19.0944 12.6762C19.9605 12.5691 20.7498 11.8568 20.7498 10.8705L19.2498 10.8705ZM19.0397 1.77527C19.136 1.77019 19.2498 1.85085 19.2498 2L20.7498 2C20.7498 1.04458 19.9675 0.224316 18.9608 0.277344L19.0397 1.77527Z",
                fill: color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M34.9814 10.3702C35.4377 10.0742 36.0496 10.1959 36.3312 10.6613C37.68 12.8896 38.5431 15.3702 38.8617 17.9474C39.2202 20.8467 38.8796 23.7879 37.8672 26.5357C36.8547 29.2835 35.1985 31.7618 33.0309 33.7726C30.8633 35.7835 28.2443 37.271 25.3833 38.1164L22.2095 27.8618C23.4336 27.5001 24.5541 26.8637 25.4816 26.0033C26.4091 25.143 27.1177 24.0826 27.5509 22.9069C27.984 21.7312 28.1298 20.4728 27.9764 19.2322C27.8647 18.3288 27.5966 17.4531 27.186 16.6418C26.9328 16.1415 27.0543 15.5115 27.5246 15.2064L34.9814 10.3702Z",
                fill: color,
                fillOpacity: "0.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M38.8617 17.9474L38.1174 18.0394L38.8617 17.9474ZM25.3833 38.1164L24.6669 38.3381L24.8858 39.0454L25.5959 38.8356L25.3833 38.1164ZM22.2095 27.8618L21.9969 27.1426L21.2684 27.3579L21.493 28.0836L22.2095 27.8618ZM27.9764 19.2322L27.2321 19.3243L27.9764 19.2322ZM27.186 16.6418L26.5168 16.9804L27.186 16.6418ZM27.5246 15.2064L27.1165 14.5772L27.5246 15.2064ZM34.9814 10.3702L34.5733 9.74093L34.9814 10.3702ZM35.6896 11.0496C36.984 13.1882 37.8118 15.5679 38.1174 18.0394L39.606 17.8553C39.2743 15.1725 38.3759 12.591 36.9729 10.2729L35.6896 11.0496ZM38.1174 18.0394C38.4611 20.8198 38.1346 23.6405 37.1634 26.2764L38.5709 26.795C39.6246 23.9352 39.9792 20.8737 39.606 17.8553L38.1174 18.0394ZM37.1634 26.2764C36.1922 28.9124 34.6028 31.2914 32.5208 33.2228L33.541 34.3225C35.7942 32.2322 37.5173 29.6546 38.5709 26.795L37.1634 26.2764ZM32.5208 33.2228C30.4388 35.1542 27.9219 36.5842 25.1708 37.3971L25.5959 38.8356C28.5667 37.9578 31.2878 36.4127 33.541 34.3225L32.5208 33.2228ZM26.0998 37.8946L22.9259 27.6401L21.493 28.0836L24.6669 38.3381L26.0998 37.8946ZM22.422 28.5811C23.756 28.1869 24.9786 27.4929 25.9917 26.5532L24.9715 25.4535C24.1297 26.2344 23.1112 26.8133 21.9969 27.1426L22.422 28.5811ZM25.9917 26.5532C27.0048 25.6133 27.7802 24.4537 28.2546 23.1662L26.8471 22.6476C26.4551 23.7114 25.8133 24.6726 24.9715 25.4535L25.9917 26.5532ZM28.2546 23.1662C28.729 21.8785 28.8888 20.4997 28.7207 19.1402L27.2321 19.3243C27.3707 20.4458 27.2391 21.5838 26.8471 22.6476L28.2546 23.1662ZM28.7207 19.1402C28.5983 18.1502 28.3046 17.1911 27.8552 16.3031L26.5168 16.9804C26.8886 17.7151 27.1311 18.5074 27.2321 19.3243L28.7207 19.1402ZM27.9327 15.8357L35.3895 10.9994L34.5733 9.74093L27.1165 14.5772L27.9327 15.8357ZM27.8552 16.3031C27.7475 16.0904 27.8326 15.9006 27.9327 15.8357L27.1165 14.5772C26.2759 15.1224 26.1182 16.1927 26.5168 16.9804L27.8552 16.3031ZM36.9729 10.2729C36.4586 9.42333 35.3628 9.22886 34.5733 9.74093L35.3895 10.9994C35.5127 10.9195 35.6405 10.9685 35.6896 11.0496L36.9729 10.2729Z",
                fill: color
            })
        ]
    }));
};



/***/ }),

/***/ 71606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ LaptopIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);




var LaptopIcon = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 54 : _width, _height = _param.height, height = _height === void 0 ? 39 : _height, _color = _param.color, color = _color === void 0 ? "currentColor" : _color, _strokeColor = _param.strokeColor, strokeColor = _strokeColor === void 0 ? "currentColor" : _strokeColor, _strokeWidth = _param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 1.5 : _strokeWidth, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height",
        "color",
        "strokeColor",
        "strokeWidth"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: width,
        height: height,
        viewBox: "0 0 54 39",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14 30H53L40 34.5H1L14 30Z",
                fill: "#ADBACC",
                fillOpacity: "0.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M40 34.5H1V36.5C1 37.0523 1.44772 37.5 2 37.5H40V34.5Z",
                fill: "#ADBACC",
                fillOpacity: "0.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M53 30L40 34.5V37.5L53 33V30Z",
                fill: "#ADBACC",
                fillOpacity: "0.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14 30H53V4C53 2.34315 51.6569 1 50 1H17C15.3431 1 14 2.34315 14 4V30ZM50.5 27H16.5V4H50.5V27Z",
                fill: color,
                fillOpacity: "0.25"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14 30H53M14 30L1 34.5M14 30V4C14 2.34315 15.3431 1 17 1H50C51.6569 1 53 2.34315 53 4V30M53 30L40 34.5M53 30V33L40 37.5M40 34.5H1M40 34.5V37.5M1 34.5V36.5C1 37.0523 1.44772 37.5 2 37.5H40M16.5 27H50.5V4H16.5V27Z",
                stroke: strokeColor,
                strokeWidth: strokeWidth,
                strokeLinejoin: "round"
            })
        ]
    }));
};



/***/ }),

/***/ 34246:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"advisors-header":"AdvisorsHeader_advisors-header___fBlr","advisors-header-details":"AdvisorsHeader_advisors-header-details__oVqyW","learn-more-row":"AdvisorsHeader_learn-more-row__Ubkmp","coming-soon":"AdvisorsHeader_coming-soon__9g1th","slide":"AdvisorsHeader_slide__w_2y1","dash":"AdvisorsHeader_dash__BJR5R","spin":"AdvisorsHeader_spin__XAV9U","rotate":"AdvisorsHeader_rotate__TUqGe","floating":"AdvisorsHeader_floating__dw0Ii"};

/***/ }),

/***/ 89320:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fee-section":"FeeComparison_fee-section__yODPl","fee-comparison":"FeeComparison_fee-comparison__4Bdsq","logo-cell":"FeeComparison_logo-cell__BH_5_","full-row-col":"FeeComparison_full-row-col__nSGAX","fake-second-header":"FeeComparison_fake-second-header__SBm5W","fee-footnote":"FeeComparison_fee-footnote__qC0ow","slide":"FeeComparison_slide__TA9Hf","dash":"FeeComparison_dash__HPTJI","spin":"FeeComparison_spin__on_y5","rotate":"FeeComparison_rotate__pH_q1","floating":"FeeComparison_floating__SzgDK"};

/***/ }),

/***/ 16962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-table":"CardTable_card-table__u7RX_","card-table-header":"CardTable_card-table-header__AiiU1","card-table-column":"CardTable_card-table-column__lkwX9","center":"CardTable_center__JREo_","card-table-row":"CardTable_card-table-row__UVtds","bold":"CardTable_bold__hxBli","slide":"CardTable_slide__kiOUb","dash":"CardTable_dash__PAmP3","spin":"CardTable_spin__hGjxu","rotate":"CardTable_rotate__nu7cf","floating":"CardTable_floating__hLQHD"};

/***/ }),

/***/ 85849:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"double-feature":"DoubleFeature_double-feature__lg1l9","slide":"DoubleFeature_slide__7LiI6","dash":"DoubleFeature_dash__Fe1sr","spin":"DoubleFeature_spin__uk128","rotate":"DoubleFeature_rotate__zSzvY","floating":"DoubleFeature_floating__aRgJh"};

/***/ }),

/***/ 46151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text-grid-container":"TextGridWithLogo_text-grid-container__qmqiC","rotate":"TextGridWithLogo_rotate__kLtFh","text-grid":"TextGridWithLogo_text-grid__YDEGt","pill":"TextGridWithLogo_pill___DNOu","text-item":"TextGridWithLogo_text-item__Zo2zd","coming-soon":"TextGridWithLogo_coming-soon__AfqEn","slide":"TextGridWithLogo_slide__L5i3E","dash":"TextGridWithLogo_dash__5TxVp","spin":"TextGridWithLogo_spin__iSKn3","floating":"TextGridWithLogo_floating__fGC_Z"};

/***/ }),

/***/ 78091:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"two-screens-section":"TwoScreensSection_two-screens-section__Uu4oR","screenshot":"TwoScreensSection_screenshot__pSfTy","slide":"TwoScreensSection_slide__rNqkt","dash":"TwoScreensSection_dash__DutK5","spin":"TwoScreensSection_spin__NgPj4","rotate":"TwoScreensSection_rotate__OrUWQ","floating":"TwoScreensSection_floating__I1VDh"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [652,602,577,253,389,486,774,888,179], function() { return __webpack_exec__(8264); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);